import { ReactNode, useEffect, useState } from 'react';

interface DelayedRenderProps {
    delay: number;
    children: ReactNode;
}

export function DelayedRender({ delay, children }: DelayedRenderProps) {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setShow(true), delay);
        return () => clearTimeout(timer);
    }, [delay]);

    return show ? children : null;
}
